// @ts-check

import React from 'react';
import { array, string } from 'prop-types';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

/**
 * @component ProfileAutocomplete
 * @param {Object} props
 * @param {string} props.name
 * @param {string} props.label
 * @param {Object[]} props.options
 * @param {Object[]} props.values
 * @returns {JSX.Element}
 */
function ProfileAutocomplete({ name, label, options, values }) {
	return (
		<Autocomplete
			sx={{ '& .MuiAutocomplete-popupIndicator': { display: 'none' } }}
			multiple
			defaultValue={values}
			options={options}
			getOptionLabel={(option) => option[name]}
			fullWidth
			readOnly
			renderInput={(params) => (
				<TextField
					{...params}
					sx={{
						'& fieldset': { border: 'none' },
						'& .MuiInputLabel-root': { color: 'var(--cl-paper-text-main)' },
					}}
					variant="outlined"
					label={label}
					InputLabelProps={{ shrink: true }}
				/>
			)}
		/>
	);
}

ProfileAutocomplete.propTypes = {
	name: string,
	label: string,
	options: array,
	values: array,
};

export default ProfileAutocomplete;
